/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuoteCreateDto } from '../../models/sales-quote-create-dto';
import { SalesQuoteResponseDto } from '../../models/sales-quote-response-dto';

export interface QuotesControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: SalesQuoteCreateDto
}

export function quotesControllerCreate(http: HttpClient, rootUrl: string, params: QuotesControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, quotesControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesQuoteResponseDto>;
    })
  );
}

quotesControllerCreate.PATH = '/o2-sales/quotes/{tenant}';
